
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Field, fields, fieldValue, InstrumentData } from '../fields'

@Component
export default class InstrumentDetail extends Vue {
  @Prop({ required: true }) readonly value!: InstrumentData
  fields = fields

  display(field: Field) {
    return fieldValue(this.value, field)
  }
}
